//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosPost } from '../../axios/axios.js'
import { mapGetters, mapActions } from 'vuex'
import { formatPhoneNumber } from '../../components/helpers.js'

export default {
  data: function () {
    return {
      loading: false,
      actualPhone1: null,
      actualEmail: null,
      skipActualizationCount: 0
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    hasChanges: function () {
      if (this.user && this.user.employee) {
        return this.actualPhone1 !== this.user.employee.phone1 || this.actualEmail !== this.user.employee.email
      }
      return false
    }
  },
  created: function () {
    if (this.user && this.user.employee) {
      this.actualPhone1 = formatPhoneNumber(this.user.employee.phone1)
      this.actualEmail = this.user.employee.email
      this.skipActualizationCount = this.user.skipActualizationCount || 0
    }
  },
  methods: {
    ...mapActions({
      setUser: 'setUser'
    }),
    convertToServerPhoneNumber (phone) {
      if (phone != null && typeof phone === 'string' && phone.length) {
        return '8' + phone
      }
      return null
    },
    validate: function () {
      let valid = true
      valid &= this.$refs.phone1.validate()
      valid &= this.$refs.email.validate()
      return valid
    },
    isValidPhone (phone) {
      return phone && phone.length === 10
    },
    isValidEmail (email) {
      if (email && email.length) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email) || 'Некорректные данные'
      }
      return false
    },
    onActualize: function () {
      if (!this.validate()) {
        return
      }

      this.loading = true
      const bodyFormData = new FormData()
      bodyFormData.set('id', this.user.employee && this.user.employee.id)
      bodyFormData.set('merge', 'rewrite')
      bodyFormData.set('props', JSON.stringify({
        actualPhone1: this.convertToServerPhoneNumber(this.actualPhone1),
        actualEmail: this.actualEmail,
        showActualizationForm: false
      }))

      return axiosPost({
        url: 'service/obj/setproperties',
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешная актуализация',
            progress: true,
            timeout: 3000
          })
          this.$emit('close')
        },
        onFailure: 'Ошибка актуализации'
      }).finally(() => {
        this.loading = false
      })
    },
    onSkipActualization: function () {
      this.loading = true
      const bodyFormData = new FormData()
      bodyFormData.set('id', this.user.employee && this.user.employee.id)
      bodyFormData.set('merge', 'rewrite')
      bodyFormData.set('props', JSON.stringify({
        skipActualizationCount: this.skipActualizationCount + 1
      }))

      return axiosPost({
        url: 'service/obj/setproperties',
        data: bodyFormData,
        onSuccess: () => {
          localStorage.setItem('showActualizationFormLater', true)
          this.$emit('close')
        },
        onFailure: 'Ошибка заполнения позже'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
